import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header: React.FC = () => {
  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-50 bg-white/95 dark:bg-gray-900/95 backdrop-blur-md border-b border-gray-200 dark:border-gray-700"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div>
              <h1 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
                Lawyers UAE
              </h1>
              <p className="text-xs text-gray-600 dark:text-gray-300">
                Lawyers Consultants Translators
              </p>
            </div>
          </Link>


          {/* Sponsor Logo */}
          <div className="flex items-center">
            {/* LM-final logo for light mode */}
            <img
              src="/LM-final.png"
              alt="Legal Meet Sponsor Logo"
              className="h-8 sm:h-10 w-auto max-w-[120px] sm:max-w-[150px] dark:hidden"
            />
            {/* White logo for dark mode */}
            <img
              src="/sponsor-logo-white.png"
              alt="Legal Meet Sponsor Logo"
              className="h-8 sm:h-10 w-auto max-w-[120px] sm:max-w-[150px] hidden dark:block"
            />
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;